import { render, staticRenderFns } from "./father-profile.vue?vue&type=template&id=4fb7187f&scoped=true&"
import script from "./father-profile.vue?vue&type=script&lang=js&"
export * from "./father-profile.vue?vue&type=script&lang=js&"
import style0 from "./father-profile.vue?vue&type=style&index=0&id=4fb7187f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7187f",
  null
  
)

export default component.exports